import {
  TextField,
  Typography,
  List,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import styled from 'styled-components';
import Select from '../../../../../components/v2/Select';

const Text = styled(Typography)`
  margin-bottom: 5px;
`;

const Container = styled.div`
  padding: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 50%;
`;

const EmptyFeed = styled.div`
  width: 100%;
  height: 100%;
`;

const Title = styled(Text)`
  font-weight: bold !important;
  font-size: 24px !important;
`;

const Description = styled(Text)`
  font-size: 16px !important;
  margin-bottom: 15px !important;
`;

const InputContainer = styled.div`
  width: 100%;
  display: flex;
  margin: 20px 0;
`;

const StyledHabitInput = styled(TextField)`
  width: 100%;
  min-width: 300px;
  box-sizing: initial;
`;

const StyledButton = styled(LoadingButton)`
  margin-left: 10px;
  min-width: 140px;
  white-space: nowrap;
`;

const StyledList = styled(List)`
  height: auto;
  overflow-y: auto;
`;

const StyledSelectField = styled(Select)`
  margin-bottom: 20px;
  width: 50%;
  height: 55px;
`;

export {
  Container,
  EmptyFeed,
  Title,
  Description,
  InputContainer,
  StyledHabitInput,
  StyledButton,
  StyledList,
  StyledSelectField,
};
